import { FaIcon } from '@ifixit/ui/components/icon';
import { useTranslations } from '@ifixit/i18n/hooks';
import { cn } from '@ifixit/ui/lib/utils';

interface WorkbenchIconProps {
   onClick: () => void;
   className?: string;
}

export function WorkbenchIcon({ onClick, className }: WorkbenchIconProps) {
   const t = useTranslations('Workbench');

   return (
      <button
         type="button"
         aria-label={t('openWorkbench')}
         onClick={onClick}
         id="workbenchDropdownToggle"
         className={cn(
            'inline-flex items-center justify-center rounded-md p-2 text-white transition-opacity duration-300 hover:opacity-70 active:bg-gray-900',
            className
         )}
      >
         <FaIcon name="toolbox" className="size-6" />
      </button>
   );
}
